export default [
    {
        path: '/currencies',
        props: true,
        component: () => import('@/views/Currency'),
    },
];